import { FC, ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { useWeb3React } from '@web3-react/core';
import { Connector } from '@web3-react/types';
import Stack from '@mui/material/Stack';

// Assets
import { ReactComponent as IconWarning } from 'Components/ds/assets/icon-warning.svg';

// Components
import MapleContainer from 'Components/ds/MapleContainer';
import MapleButton from 'Components/ds/MapleButton';
import MapleCard from 'Components/ds/MapleCard';
import MapleCardHeader from 'Components/ds/MapleCardHeader';
import MapleCardContent from 'Components/ds/MapleCardContent';
import Typography from 'Components/ds/Typography';
import Icon3D from 'Components/ds/Icon3D';

// Services
import { clearWeb3ConnectorCache } from 'Services/web3/utils';
import { tryDeactivateConnector } from 'Services/web3/connectors';

const WrongNetwork: FC = (): ReactElement => {
  const { t } = useTranslation('common');
  const { connector } = useWeb3React();

  const clearCacheAndDisconnect = async (connector: Connector) => {
    clearWeb3ConnectorCache();
    await tryDeactivateConnector(connector);
  };

  return (
    <MapleContainer maxWidth='sm' sx={{ my: 8 }}>
      <Stack direction='column' alignItems='center' spacing={5}>
        <MapleCard sx={{ maxWidth: '600px', margin: '100px auto 0 auto' }}>
          <MapleCardHeader title={t('app.notification.walletConection.error.network.title')} />
          <MapleCardContent>
            <Stack alignItems='center' spacing={2}>
              <Icon3D
                variant='error'
                icon={
                  <Icon3D icon={<IconWarning />} variant='error' size='xSmall' borderintensity={500} shape='triangle' />
                }
              />
              <Typography sx={{ margin: '20px 0' }}>
                {t('app.notification.walletConection.error.network.copy')}
              </Typography>
            </Stack>
          </MapleCardContent>
        </MapleCard>
        <MapleButton
          variant='outlined'
          color='error'
          onClick={() => clearCacheAndDisconnect(connector)}
          sx={{ minWidth: '150px' }}
        >
          {t('app.notification.walletConection.error.clearCache')}
        </MapleButton>
      </Stack>
    </MapleContainer>
  );
};

export default WrongNetwork;
